import React, { Component } from 'react';

export class PasswordResetComplete extends Component {

    render() {
        return (
            <div>
                <h4>New Password Set!</h4>
		        <p>You may <a href="/Login" title="Link to the login page">login</a> with your new password.</p>
            </div>
        );
    }
}
